"use strict";

exports.__esModule = true;
exports.AtlasAttachmentLoader = void 0;

var _BoundingBoxAttachment = require("./attachments/BoundingBoxAttachment");

var _ClippingAttachment = require("./attachments/ClippingAttachment");

var _MeshAttachment = require("./attachments/MeshAttachment");

var _PathAttachment = require("./attachments/PathAttachment");

var _PointAttachment = require("./attachments/PointAttachment");

var _RegionAttachment = require("./attachments/RegionAttachment");

/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated January 1, 2020. Replaces all prior versions.
 *
 * Copyright (c) 2013-2020, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/

/** An {@link AttachmentLoader} that configures attachments using texture regions from an {@link TextureAtlas}.
 *
 * See [Loading skeleton data](http://esotericsoftware.com/spine-loading-skeleton-data#JSON-and-binary-data) in the
 * Spine Runtimes Guide. */
var AtlasAttachmentLoader = /*#__PURE__*/function () {
  function AtlasAttachmentLoader(atlas) {
    this.atlas = null;
    this.atlas = atlas;
  }

  var _proto = AtlasAttachmentLoader.prototype;

  _proto.newRegionAttachment = function newRegionAttachment(skin, name, path) {
    var region = this.atlas.findRegion(path);
    if (!region) throw new Error("Region not found in atlas: " + path + " (region attachment: " + name + ")");
    region.renderObject = region;
    var attachment = new _RegionAttachment.RegionAttachment(name);
    attachment.setRegion(region);
    return attachment;
  };

  _proto.newMeshAttachment = function newMeshAttachment(skin, name, path) {
    var region = this.atlas.findRegion(path);
    if (!region) throw new Error("Region not found in atlas: " + path + " (mesh attachment: " + name + ")");
    region.renderObject = region;
    var attachment = new _MeshAttachment.MeshAttachment(name);
    attachment.region = region;
    return attachment;
  };

  _proto.newBoundingBoxAttachment = function newBoundingBoxAttachment(skin, name) {
    return new _BoundingBoxAttachment.BoundingBoxAttachment(name);
  };

  _proto.newPathAttachment = function newPathAttachment(skin, name) {
    return new _PathAttachment.PathAttachment(name);
  };

  _proto.newPointAttachment = function newPointAttachment(skin, name) {
    return new _PointAttachment.PointAttachment(name);
  };

  _proto.newClippingAttachment = function newClippingAttachment(skin, name) {
    return new _ClippingAttachment.ClippingAttachment(name);
  };

  return AtlasAttachmentLoader;
}();

exports.AtlasAttachmentLoader = AtlasAttachmentLoader;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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